// extracted by mini-css-extract-plugin
export default {"health-box":"HealthBar_health-box__ERhNE","health-bar":"HealthBar_health-bar__A7tNe","health-value":"HealthBar_health-value__h1-9E"};